import envConfig from './envConfig';

export const __DEV__ = true;
export const __ENV_CONFIG__ = envConfig;

export default {
	__DEV__,
	__ENV_CONFIG__,
};
